import andIcon from '@/assets/svg/and.svg'
import orIcon from '@/assets/svg/or.svg'
import notIcon from '@/assets/svg/not.svg'
import minusIcon from '@/assets/svg/minus.svg'

const operator = {
  OR: {
    value: 'OR',
    icon: {
      class: 'operator-icon--or',
      svg: orIcon,
      width: 18,
      height: 18,
    },
  },
  AND: {
    value: 'AND',
    icon: {
      class: 'operator-icon--and',
      svg: andIcon,
      width: 14,
      height: 14,
    },
  },
  NOT: {
    value: 'NOT',
    icon: {
      class: 'operator-icon--not',
      svg: notIcon,
      width: 18,
      height: 18,
    },
  },
  "-": {
    value: '-',
    icon: {
      class: 'operator-icon--minus',
      svg: minusIcon,
      width: 18,
      height: 18,
    },
  },
  get default() {
    return this.or
  },
}

export default operator



// WEBPACK FOOTER //
// ./src/app/appComponents/workbench/targetDefinition/models/operators.js